import moment, { Moment } from 'moment';
import { FinanceDateType, DealStatus, PaymentType } from '@trnsact/trnsact-shared-types';

export type FinanceDateRange = 'cm' | 'lm' | 'cq' | 'lq' | '30' | '90' | '180' | '365' | 'custom';

export type FinanceDealStatus = DealStatus | 'ALL';
export type FinancePaymentType = PaymentType | 'ALL';

export interface CustomDateRangeValue {
  from: string;
  to: string;
}

export interface SharedFinanceFilters {
  dateRange: FinanceDateRange;
  customDateRange: CustomDateRangeValue | null;
  dealStatus: FinanceDealStatus;
  paymentType: FinancePaymentType;
  dateType: FinanceDateType;
}

export const INITIAL_SHARED_FINANCE_FILTERS: SharedFinanceFilters = {
  dateRange: '30',
  customDateRange: null,
  dealStatus: 'ALL',
  paymentType: 'ALL',
  dateType: FinanceDateType.CreatedOn,
};

/** Converts a PerformanceDateRange preset to the corresponding Moment from/to range. */
export function dateRangeToMoments(
  range: FinanceDateRange,
  customRange?: CustomDateRangeValue | null
): { from: Moment; to: Moment } {
  switch (range) {
    case 'custom':
      if (customRange?.from && customRange?.to) {
        return { from: moment(customRange.from).startOf('day'), to: moment(customRange.to).endOf('day') };
      }
      return { from: moment().subtract(30, 'days').startOf('day'), to: moment().endOf('day') };
    case 'cm':
      return { from: moment().startOf('month'), to: moment().endOf('month') };
    case 'lm':
      return {
        from: moment().subtract(1, 'month').startOf('month'),
        to: moment().subtract(1, 'month').endOf('month'),
      };
    case 'cq':
      return { from: moment().startOf('quarter'), to: moment().endOf('quarter') };
    case 'lq':
      return {
        from: moment().subtract(1, 'quarter').startOf('quarter'),
        to: moment().subtract(1, 'quarter').endOf('quarter'),
      };
    case '30':
      return { from: moment().subtract(30, 'days').startOf('day'), to: moment().endOf('day') };
    case '90':
      return { from: moment().subtract(90, 'days').startOf('day'), to: moment().endOf('day') };
    case '180':
      return { from: moment().subtract(180, 'days').startOf('day'), to: moment().endOf('day') };
    case '365':
      return { from: moment().subtract(365, 'days').startOf('day'), to: moment().endOf('day') };
  }
}
